"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with file uploading
 */
class FileUploadingApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._defaultQuery = {
            type: null,
            entity: null,
            id: null,
            width: null,
            height: null,
            compress: null,
        };
        this._url += '/api/content/files';
    }
    /**
     * Upload file function.
     *
     * @param {Event} [data] Array of Express.Multer.File objects
     *
     * @param {IUploadingQuery} [userQuery] - Optional set query parameters.
     * @param {string} [userQuery.type] - Type, determines the folder name in the storage. Example : "page"
     * @param {string} [userQuery.entity] - Entity name from which the file is uploaded, determines the folder name in the storage. Example : "editor"
     * @param {number} [userQuery.id] - Identifier of the object from which the file is uploaded, determines the folder name in the storage. Example : 3787
     * @param {number} [userQuery.width] - Width parameter. Example : 0
     * @param {number} [userQuery.height] - Height parameter. Example : 0
     * @param {boolean} [userQuery.compress] - Flag of optimization (compression) for images. Example : true
     *
     * @returns Uploads a file to an Amazon S3-compatible cloud file storage
     */
    async upload(data, userQuery) {
        const query = { ...this._defaultQuery, ...userQuery };
        const result = await this._fetchPost('?' + this._queryParamsToString(query), data);
        return result;
    }
    /**
     * Deletes a file from the cloud file storage.
     *
     * @param {string} [filename] File name. Example "file.png"
     *
     * @param {IUploadingQuery} [userQuery] - Optional set query parameters.
     * @param {string} [userQuery.type] - Type, determines the folder name in the storage. Example : "page"
     * @param {string} [userQuery.entity] - Entity name from which the file is uploaded, determines the folder name in the storage. Example : "editor"
     * @param {number} [userQuery.id] - Identifier of the object from which the file is uploaded, determines the folder name in the storage. Example : 3787
     *
     * @returns Deletes a file from the cloud file storage
     */
    async delete(filename, userQuery) {
        const query = { ...this._defaultQuery, ...userQuery };
        const result = await this._fetchDelete(`?filename=${filename}&` + this._queryParamsToString(query));
        return result;
    }
    /**
     * Get file by parameters.
     *
     * @param {number} [id] Object identifier, from which the file is uploaded, determines the folder name in the storage
     *
     * @param {string} [type] - Type, determines the folder name in the storage
     * @param {string} [entity] - entity name, from which the file is uploaded, determines the folder name in the storage
     * @param {string} [filename] - Filename. Example "file.png"
     *
     * @returns Return file as File object
     */
    async getFile(id, type, entity, filename) {
        const result = await this._fetchGet(`?id=${id}&type=${type}&entity=${entity}${filename ? `&filename=${filename}` : ''}`);
        return result;
    }
}
exports.default = FileUploadingApi;
